// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carriers-container {
  width: 100%;
  padding: 50px;
  margin-left: 18%;
}
@media (max-width: 1024px) {
  .carriers-container {
    width: 71%;
    margin-left: 28%;
  }
}
.carriers-container .carriers-inner-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(7, 1fr);
  grid-column-gap: 40px;
  grid-row-gap: 40px;
}

.carrier-items {
  height: 300px;
  width: 100%;
  border-bottom: 2px solid rgba(115, 115, 115, 0.313);
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.carrier-items .CarrierItemDropdown .carrier-button {
  display: flex;
  background-color: #003478;
  color: white !important;
  width: 100%;
  font-size: 12px;
  padding: 15px 10px;
}
.carrier-items .CarrierItemDropdown .carrier-button:hover {
  background-color: "#003478";
}
.carrier-items .CarrierItemDropdown .carrier-button .carrier-link {
  text-decoration: none;
  color: white !important;
}
.carrier-items .CarrierItemDropdown .css-lpyore-MuiButtonBase-root-MuiButton-root {
  width: 311px !important;
}
.carrier-items .btn-flex {
  display: flex;
  align-items: center;
  gap: 30px;
}
.carrier-items img {
  width: 100%;
  height: 60%;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/components/Carriers/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AACF;AACE;EALF;IAMI,UAAA;IACA,gBAAA;EAEF;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;AAEJ;;AAEA;EACE,aAAA;EACA,WAAA;EACA,mDAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AACF;AAEI;EACE,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAAN;AAEM;EACE,2BAAA;AAAR;AAGM;EACE,qBAAA;EACA,uBAAA;AADR;AAWI;EACE,uBAAA;AATN;AAYE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAVJ;AAYE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;AAVJ","sourcesContent":[".carriers-container {\r\n  width: 100%;\r\n  padding: 50px;\r\n  margin-left: 18%;\r\n\r\n  @media (max-width: 1024px) {\r\n    width: 71%;\r\n    margin-left: 28%;\r\n  }\r\n\r\n  .carriers-inner-container {\r\n    width: 100%;\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    grid-template-rows: repeat(7, 1fr);\r\n    grid-column-gap: 40px;\r\n    grid-row-gap: 40px;\r\n  }\r\n}\r\n\r\n.carrier-items {\r\n  height: 300px;\r\n  width: 100%;\r\n  border-bottom: 2px solid rgba(115, 115, 115, 0.313);\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-evenly;\r\n\r\n  .CarrierItemDropdown {\r\n    .carrier-button {\r\n      display: flex;\r\n      background-color: #003478;\r\n      color: white !important;\r\n      width: 100%;\r\n      font-size: 12px;\r\n      padding: 15px 10px;\r\n\r\n      &:hover {\r\n        background-color: \"#003478\";\r\n      }\r\n\r\n      .carrier-link {\r\n        text-decoration: none;\r\n        color: white !important;\r\n      }\r\n    }\r\n\r\n    // .carrier-link {\r\n    //     text-decoration: none;\r\n    //     color: white\r\n    // }\r\n\r\n    // width: 226px !important;\r\n    .css-lpyore-MuiButtonBase-root-MuiButton-root {\r\n      width: 311px !important;\r\n    }\r\n  }\r\n  .btn-flex {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 30px;\r\n  }\r\n  img {\r\n    width: 100%;\r\n    height: 60%;\r\n    object-fit: contain;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
